function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
var duration = 500;
var transition = ["transform ".concat(duration, "ms ease-in-out"), "opacity ".concat(duration, "ms ease-in-out")].join();
var activeStyle = {
  transition: transition,
  transform: 'translate(0, 0)',
  opacity: 1.0
};
var inactiveStyle = {
  transition: transition,
  transform: 'translate(0, -100px)',
  opacity: 0
};
var transitionStyles = {
  entering: activeStyle,
  entered: activeStyle,
  exiting: inactiveStyle,
  exited: inactiveStyle
};

var SnackbarTransition = /*#__PURE__*/function (_React$Component) {
  _inherits(SnackbarTransition, _React$Component);

  var _super = _createSuper(SnackbarTransition);

  function SnackbarTransition(props) {
    var _this;

    _classCallCheck(this, SnackbarTransition);

    _this = _super.call(this, props);
    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(SnackbarTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: _this2.props.active
        });
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onTransitionComplete = _this$props.onTransitionComplete,
          children = _this$props.children;
      var active = this.state.active;
      return /*#__PURE__*/React.createElement(Transition, {
        "in": active,
        timeout: duration,
        onEntered: onTransitionComplete,
        onExited: onTransitionComplete
      }, function (state) {
        return /*#__PURE__*/React.createElement("div", {
          style: transitionStyles[state]
        }, children);
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.active !== prevState.active) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          active: nextProps.active
        });
      }

      return null;
    }
  }]);

  return SnackbarTransition;
}(React.Component);

SnackbarTransition.defaultProps = {
  active: true
};
SnackbarTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  children: PropTypes.element.isRequired,
  onTransitionComplete: PropTypes.func
} : {};
export default SnackbarTransition;
//# sourceMappingURL=SnackbarTransition.js.map